import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=6f6be2c4&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=6f6be2c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6be2c4",
  null
  
)

export default component.exports